import React, { useEffect, useState, useCallback } from "react";
import LabelInput from "../../../../../shared/components/labelInput";
import { useForm } from "react-hook-form";
import { fetchLicenceAuth } from "../../../../../shared/services/simpleListItemsService";
import NewDateTimePicker from "../../../../../shared/components/newDateTimePicker";
import RadioGroup from "../../../../../shared/components/RadioGroup";
import SpUseMapper from "../mappers/spUseMapper";
import QuoteFormWrapper from "../../../../../shared/components/quoteFormWrapper";
import SupportNavigationButtons from "../../../components/support/SupportNavigationButtons";
import { handleSupportNext } from "../../../utils/supportNavUtils";
import { useNavigate } from "react-router-dom";
import FieldStack from "../../../../../shared/components/FieldStack";
import QuoteStepHeading from "../../../../../shared/components/QuoteStepHeading";

const SpUse = () => {
  const {
    register,
    watch,
    setValue,
    control,
    trigger,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    defaultValues: SpUseMapper.get(),
    mode: "onChange",
  });

  const vehicleHireOptions = [
    {
      value: "private_hire",
      label: "Private Hire",
    },
    { value: "public_hire", label: "Public Hire/Hackney carriage" },
  ];

  const [lic, setlic] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const convertArrayFormat = useCallback((array) => {
    if (!Array.isArray(array)) {
      return [];
    }
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  }, []);

  useEffect(() => {
    setIsLoading(true);
    fetchLicenceAuth()
      .then((uber) => setlic(uber))
      .finally(() => setIsLoading(false));
  }, []);

  const onSubmit = (data) => {
    SpUseMapper.set(data);
    handleSupportNext(navigate);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <QuoteFormWrapper>
        <QuoteStepHeading title="Change of use" className="tw-mb-6" />
        <FieldStack className="tw-w-full">
        <LabelInput
          id="hireType"
          label="What is your new use"
          type="select"
          options={vehicleHireOptions}
          control={control}
          errors={errors.hireType}
          placeholder="Select hire type"
          register={register("hireType", {
            required: "Required",
          })}
          watch={watch("hireType")}
          trigger={trigger}
        />
        <RadioGroup
          name="useUpdated"
          mainLabel="Has the use been updated with your licencing authority, and have you obtained your new taxi badge? If no, you must change this with the licencing authority."
          register={register}
          trigger={trigger}
          errors={errors.useUpdated}
        />
        <RadioGroup
          name="licensingContinued"
          mainLabel="Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy? If no, please provide the new licencing authority details."
          register={register}
          trigger={trigger}
          errors={errors.licensingContinued}
        />
        {watch("licensingContinued") === "No" && (
          <LabelInput
            id="LicenseAuth"
            label="What will be the licencing authority?"
            type="select"
            options={convertArrayFormat(lic)}
            control={control}
            placeholder="Select licence authority"
            register={register("LicenseAuth", { required: true })}
            errors={errors.LicenseAuth}
            watch={watch("LicenseAuth")}
            trigger={trigger}
            isSearchable={true}
            isLoading={isLoading}
          />
        )}
        <NewDateTimePicker
          name="useEffectiveDateTime"
          label="Effective Date and Time"
          errors={errors.useEffectiveDateTime}
          setValue={setValue}
          control={control}
          rules={{ required: "Date is required" }}
          watch={watch}
          defaultValue={watch("useEffectiveDateTime")}
          minDate={new Date()}
          trigger={trigger}
        />
        </FieldStack>
      </QuoteFormWrapper>
      <SupportNavigationButtons isValid={isValid} />
    </form>
  );
};

export default SpUse;
